import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { portalRoute } from "../_portal.js";

export const portalBoardRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/board",
  component: lazyRouteComponent(() => import("./board.page.js"), "PortalBoardPage"),
});
